<template>

    <section
        id="hero"
        class="hero"
    >

        <img
            class="hero__image"
            :src="'home_hero' | staticImg"
            :alt="'home_hero' | staticTitle"
        >

        <div class="hero__overlay"></div>

        <div class="hero__container">

            <div class="hero__content">

                <h1 class="hero__title">

                    {{ 'home_hero_title' | staticTitle }}

                    <br>

                    <span>
                        {{ 'home_hero_title_accent' | staticTitle }}
                    </span>

                </h1>

                <p class="hero__text">
                    {{ 'home_hero' | staticContent }}
                </p>

                <div class="hero__buttons">

                    <router-link
                        :to="{ path: '/', hash: '#contact' }"
                        class="hero__button hero__button--primary"
                    >
                        {{ 'home_hero_primary_button' | staticTitle }}
                    </router-link>

                    <router-link
                        to="/sermons"
                        class="hero__button hero__button--secondary"
                    >
                        {{ 'home_hero_secondary_button' | staticTitle }}
                    </router-link>
                </div>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeHero'
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&display=swap');

.hero {
    position: relative;

    width: 100%;
    height: 82vh;
    min-height: 700px;

    overflow: hidden;

    padding-top: 74px;

    &__image {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        width: 100%;
        height: 100%;

        object-fit: cover;
        object-position: 62% center;
    }

    &__overlay {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background: linear-gradient(
            to top,
            rgba(0, 0, 0, .82),
            rgba(0, 0, 0, .45),
            rgba(0, 0, 0, .15)
        );
    }

    &__container {
        position: relative;

        width: 100%;
        height: 100%;

        padding: 0 20px;

        display: flex;
        align-items: flex-end;

        z-index: 2;
    }

    &__content {
        width: 100%;
        max-width: 450px;

        padding-bottom: 120px;
    }

    &__title {
        margin: 0 0 24px;

        color: var(--white);

        font-family: 'Cormorant Garamond', serif;

        font-size: 2.8rem;
        font-weight: 700;

        line-height: .95;

        text-transform: uppercase;

        span {
            color: var(--primary);
        }
    }

    &__text {
        max-width: 330px;

        margin: 0 0 36px;

        color: var(--secondary);

        font-size: 1rem;

        line-height: 1.55;
    }

    &__buttons {
        display: flex;

        gap: 10px;
    }

    &__button {
        flex: 1;

        min-height: 48px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 10px 16px;

        border-radius: 4px;

        font-size: .80rem;
        font-weight: 700;

        text-align: center;
        text-transform: uppercase;
        text-decoration: none;

        transition:
            background .3s ease,
            color .3s ease,
            border-color .3s ease,
            transform .3s ease;

        &:hover {
            transform: translateY(-2px);
        }

        &--primary {
            background: var(--primary);
            color: var(--secondary);

            &:hover {
                background: var(--primary-hover);
            }
        }

        &--secondary {
            color: var(--secondary);

            border: 2px solid rgba(255, 255, 255, .75);

            &:hover {
                background: var(--background);
                color: var(--text);

                border-color: var(--background);
            }
        }
    }
}

@media (min-width: 768px) {
    .hero {
        height: 82vh;

        &__image {
            transform: translateY(60px);
        }

        &__container {
            padding: 0 50px;
        }

        &__content {
            max-width: 560px;

            padding-bottom: 100px;
        }

        &__title {
            font-size: 4.6rem;
        }

        &__buttons {
            flex-direction: row;

            gap: 16px;
        }

        &__button {
            flex: none;

            width: 220px;
            min-height: 52px;

            font-size: .9rem;
        }
    }
}

@media (min-width: 1024px) {
    .hero {

        &__container {
            max-width: 1400px;

            margin: 0 auto;
            padding: 0 60px;
        }

        &__content {
            max-width: 620px;

            padding-bottom: 90px;
        }

        &__title {
            font-size: 5rem;
        }

        &__text {
            max-width: 500px;

            font-size: 1.2rem;
        }
    }
}
</style>